<template>
  <!-- 中心案例 -->
  <div class="case">
    <div class="banner">
      <div class="banner-inner">
        <h2 class="title">中心案例</h2>
        <ul class="menu-list flex-align">
          <li v-for="(item,index) in menuList" :key="index" class="menu-item csp"
            :class="{'active-menu':activeMenu == index}" @click="chooseMenu(index)">
            {{item.name}}
          </li>
        </ul>
      </div>
    </div>
    <div class="case-inner">
      <ul class="case-list flex-layout">
        <li class="case-item" v-for="(item,index) in 5" :key="index">
          <img src="" alt="" class="case-img">
          <span class="case-title">美育共同体</span>
          <p class="case-desc wes-3">主要从事教育基本原理、课程与教学论、教师教育、历史教学等方面的教学与研究。中国教育学会农村教育分会副秘书长。</p>
          <div class="case-info flex-align-between">
            <span class="case-sort">{{menuList[activeMenu].name}}</span>
            <span class="case-time">2022年9月</span>
          </div>
        </li>
      </ul>
      <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage" :small="true"
        :limit.sync="pages.pageSize" :pageSizes="[8,16,24]" :layout="'prev,pager,next'" @pagination="handlePageChange">
      </pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeMenu: 0,
        menuList: [{
            name: '全部',
          },
          {
            name: '区域',
          },
          {
            name: '学校',
          },
          {
            name: '其他',
          },
        ],
        pages: { //分页
          currentPage: 1,
          pageSize: 8,
          total: 100,
        },
      }
    },
    methods: {
      chooseMenu(index) {
        this.activeMenu = index;
      },
      handlePageChange() {}
    }
  }
</script>

<style lang="less" scoped>
  .case {
    .banner {
      background-image: url("../assets/case/banner.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 56vh;
      max-height: 530px;
      min-height: 360px;
      padding-left: 6.9%;
      position: relative;

      .banner-inner {
        position: absolute;
        width: 100%;
        top: 65%;
      }

      .title {
        font-size: 48px;
        color: #fff;
        margin-bottom: 2.2%;
        letter-spacing: 2px;
      }

      .menu-list {
        padding-right: 59%;
      }

      .menu-item {
        color: #fff;
        font-size: 30px;
        line-height: 1.3;
        letter-spacing: 2px;
        text-align: center;
        padding: 0 4.3%;
        border-right: 1px solid #AA89BD;
        font-weight: 300;

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          border-right: 0;
        }

        &.active-menu {
          font-weight: 500;
        }
      }
    }


    .case-inner {
      background-image: url("../assets/business/bg.png");
      background-position: bottom;
      background-repeat: no-repeat;
      padding: 3.5% 5.2% 50%;


      .case-list {
        flex-wrap: wrap;
      }


      .case-item {
        margin-right: 4.4%;
        margin-bottom: 4.2%;
        width: calc((100% - 4.8% * 2) / 3);
        border: 1px solid #d2d2d2;
        transition: 1s all;

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:nth-child(3n) .case-title {
          background-color: #00C7E5;
        }

        &:nth-child(3n+1) .case-title {
          background-color: #F39800;
        }

        &:nth-child(3n+2) .case-title {
          background-color: #298EEA;
        }

        &:hover {
          box-shadow: 0px 2px 35px 2px rgba(30, 19, 15, 0.11);
        }
      }

      .case-img {
        width: 100%;
        height: 357px;
      }


      .case-title {
        display: inline-block;
        font-size: 30px;
        color: #fff;
        line-height: 2.13;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        padding-right: 6%;
        margin: 6.3% 0;




        &::before {
          content: " ";
          display: inline-block;
          width: 17px;
          height: 17px;
          background-color: #fff;
          border-radius: 50%;
          margin: 0 12px;
          vertical-align: 2px;
        }
      }


      .case-desc {
        padding: 0 11% 0 7%;
        font-size: 20px;
        font-weight: 300;
        line-height: 1.8;
      }

      .case-info {
        padding: 7.9% 11% 11% 7%;
        font-size: 16px;
        color: #666;
        font-weight: 300;
      }


    }



    @media screen and (max-width:1850px) {
      .banner {

        .title {
          font-size: 40px;
        }


        .menu-item {
          font-size: 25px;
        }
      }

      .case-inner {
        .case-img {
          height: 298px;
        }


        .case-title {
          font-size: 25px;

          &::before {
            margin: 0 10px;
          }
        }


        .case-desc {
          font-size: 17px;
        }

        .case-info {
          font-size: 13px;
        }


      }

    }

    @media screen and (max-width:1450px) {
      .banner {

        .title {
          font-size: 31px;
        }


        .menu-item {
          font-size: 20px;
        }
      }

      .case-inner {
        .case-img {
          height: 232px;
        }


        .case-title {
          font-size: 20px;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;

          &::before {
            margin: 0 10px;
            width: 14px;
            height: 14px;
          }
        }


        .case-desc {
          font-size: 15px;
        }

        .case-info {
          font-size: 12px;
        }


      }
    }

    @media screen and (max-width:1150px) {
      .case-inner {
        .case-title {
          font-size: 20px;

        }

      }
    }
  }
</style>